import ready from '../components/_ready';

ready(() => {
  const expandedParagraph = document.querySelector('.expanded');
  const showMoreElement = document.getElementById('showMore');

  const collapsedParagraph = document.querySelector('.collapsed');
  const lessElement = document.getElementById('showLess');

  if (showMoreElement) {
    showMoreElement.addEventListener('click', () => {
      expandedParagraph.classList.remove('d-none');
      collapsedParagraph.classList.add('d-none');
    });
  }

  if (lessElement) {
    lessElement.addEventListener('click', () => {
      expandedParagraph.classList.add('d-none');
      collapsedParagraph.classList.remove('d-none');
    });
  }
});
